<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="name"
                    name="name"
                    label="Name"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="url"
                    name="url"
                    label="Url"
                    :counter="100"
                    readonly="readonly"
                    v-validate="'required|max:100'"
                    data-vv-as="url"
                    :error-messages="errors.collect('url')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="displayName"
                    name="displayName"
                    label="Display Name"
                    :counter="50"
                    v-validate="'required|max:50'"
                    data-vv-as="Display Name"
                    :error-messages="errors.collect('displayName')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md1>
                  <v-text-field
                    v-model="sort"
                    name="sort"
                    label="Sort"
                    v-validate="'required:sort|numeric'"
                    data-vv-as="Sort"
                    :error-messages="errors.collect('sort')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-switch
                    name="showInMenu"
                    data-vv-as="ShowInMenu"
                    v-model="showInMenu"
                    label="Show In Menu"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="keywords"
                    name="keywords"
                    label="Keywords"
                    :counter="300"
                    v-validate="'required|max:300'"
                    data-vv-as="Keywords"
                    :error-messages="errors.collect('keywords')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="description"
                    name="description"
                    label="Description"
                    :counter="300"
                    v-validate="'required|max:300'"
                    data-vv-as="Description"
                    :error-messages="errors.collect('description')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea
                    v-model="shortDescription"
                    name="shortDescription"
                    label="Short Description"
                    :counter="1000"
                    v-validate="'required|max:1000'"
                    data-vv-as="ShortDescription"
                    :error-messages="errors.collect('shortDescription')"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
export default {
  computed: {
    name: {
      get() {
        return this.$store.state.category.name;
      },
      set(val) {
        val = val.trim();
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "name",
          value: val
        });
        val = val.toLowerCase();
        val = val.replace(/[0-9`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "");
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "url",
          value: val.replace(/\s+/g, "-")
        });
      }
    },
    sort: {
      get() {
        return this.$store.state.category.sort;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "sort",
          value: val
        });
      }
    },
    showInMenu: {
      get() {
        return this.$store.state.category.showInMenu;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "showInMenu",
          value: val
        });
      }
    },
    displayName: {
      get() {
        return this.$store.state.category.displayName;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "displayName",
          value: val
        });
      }
    },
    shortDescription: {
      get() {
        return this.$store.state.category.shortDescription;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "shortDescription",
          value: val
        });
      }
    },
    keywords: {
      get() {
        return this.$store.state.category.keywords;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "keywords",
          value: val
        });
      }
    },
    description: {
      get() {
        return this.$store.state.category.description;
      },
      set(val) {
        this.$store.commit("category/SET_CATEGORY_DATA", {
          key: "description",
          value: val
        });
      }
    },
    url: {
      get() {
        return this.$store.state.category.url;
      }
    }
  },
  data() {
    return {
      loading: false,
      pageTitle: "Add Category"
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.dispatch("category/setCategory", { id: to.params.id }).then(() => {
        next(p => {
          p.pageTitle = "Edit Category";
        });
      });
    } else {
      next(p => {
        p.reset();
      });
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch("category/saveCategory").then(
            () => {
              commonservice.showSuccessMessage("Category saved successfully");
              this.$router.push("/category");
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        }
      });
    },
    reset() {
      this.$store.commit("category/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    }
  }
};
</script>
